<template>
  <div>
    <div class="row">
      <div class="col-sm-4">
        <table class="stats">
          <tbody>
            <tr>
              <td>
                <p><span id="replies-sent">Replies Sent</span></p>
                <b-tooltip target="replies-sent" placement="bottom">
                  Number of outgoing email replies sent from users to customers.
                </b-tooltip>
                <div class="data">{{replies}}</div>
              </td>
              <td>
                <p><span id="resolved-tickets">Resolved Tickets</span></p>
                <b-tooltip target="resolved-tickets" placement="bottom">
                  Tickets with a status of complete.
                </b-tooltip>
                <div class="data">{{resolved}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <p><span id="avg-task-time">Average Task Completion Time</span></p>
                <b-tooltip target="avg-task-time" placement="bottom">
                  The average amount of time it takes to process a task
                </b-tooltip>
                <div class="data">{{avgTaskTime}}</div>
              </td>
              <td>
                <p><span id="closed-tasks">Closed Tasks</span></p>
                <b-tooltip target="closed-tasks" placement="bottom">
                  Tasks with a status of complete.
                </b-tooltip>
                <div class="data">{{closedTasks}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <p><span id="replies-to-resolve">Replies to Resolve</span></p>
                <b-tooltip target="replies-to-resolve" placement="bottom">
                  The average number of replies sent to the customer before the conversation is resolved.
                </b-tooltip>
                <div class="data">{{avgRepliesToResolve}}</div>
              </td>
              <td>
                <p><span id="first-response-time">First Response Time</span></p>
                <b-tooltip target="first-response-time" placement="bottom">
                  The average amount of time it takes from the time a conversation is created to the time a user sends the first reply.
                </b-tooltip>
                <div class="data">{{firstResponseTime}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <p><span id="avg-ticket-time">Average Ticket Completion Time</span></p>
                <b-tooltip target="avg-ticket-time" placement="bottom">
                  The average amount of time it takes to process a ticket
                </b-tooltip>
                <div class="data">{{avgTicketTime}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="cols-sm-8">
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="First Response Time" active>
          <div class="row">
            <div class="col-sm-12">
              <DonutChart :data="firstResponseTimes" :series_title="'First Response Time'" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-table :items="firstResponseTimes" :fields="firstResponseTableFields">
                <template slot="1" slot-scope="scope">
                 {{ scope.item[1]}}%
                </template>
              </b-table>
            </div>
          </div>
        </b-tab>
        <b-tab title="Replies to Resolve">
          <div class="row">
            <div class="col-sm-6">
              <DonutChart :data="repliesToResolve" :series_title="'Replies to Resolve'"/>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-table :items="repliesToResolve" :fields="repliesTableFields">
                <template slot="1" slot-scope="scope">
                 {{ scope.item[1]}}%
                </template>
              </b-table>
            </div>
          </div>
        </b-tab>
        <b-tab title="Template Usage">
          <div class="row">
            <div class="col-sm-12">
              <b-table :items="taskTemplateCollections" :fields="taskTemplatesCollectionFields" :per-page="10" />
            </div>
          </div>
        </b-tab>
        <b-tab title="User Productivity">
          <div class="row">
            <div class="col-sm-12">
              <b-table :items="usersProductivity" :fields="usersProductivityFields" />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import DonutChart from './DonutChart'
export default {
  name: 'ProductivityReport',
  data () {
    return {
      avgTaskTime: 0,
      avgTicketTime: 0,
      resolved: 0,
      closedTasks: 0,
      replies: 0,
      firstResponseTime: 0,
      chartData: {
        categories: [],
        data: []
      },
      firstResponseTimes: [],
      repliesToResolve: [],
      usersProductivity: [],
      usersProductivityFields: {
        '0': {
          label: 'Name',
          sortable: true
        },
        '1': {
          label: 'Completed Tasks',
          sortable: true
        },
        '2': {
          label: 'Resolved Tickets',
          sortable: true
        },
        '3': {
          label: 'Task Value',
          sortable: true
        },
        '4': {
          label: 'Task Completion Time',
          sortable: true,
          formatter: this.timeFormatter
        },
        '5': {
          label: 'Ticket Resolution Time',
          sortable: true,
          formatter: this.timeFormatter
        }
      },
      firstResponseTableFields: {
        '0': {
          label: 'Time',
          sortable: true
        },
        '1': {
          label: '%',
          sortable: true
        }
      },
      repliesTableFields: {
        '0': {
          label: 'Replies',
          sortable: true
        },
        '1': {
          label: '%',
          sortable: true
        }
      },
      taskTemplateCollections: [],
      taskTemplatesCollectionFields: {
        '0': {
          label: 'Template',
          sortable: true
        },
        '1': {
          label: '#',
          sortable: true
        }
      },
      avgRepliesToResolve: 0
    }
  },
  components: {
    DonutChart
  },
  created () {
    this.getData()
  },
  computed: {
    ...mapGetters(['currentReportMailbox', 'reportDates']),
    chartOptions: function () {
      return {
        chart: {
          type: 'line',
          plotBorderWidth: 1,
          width: 800
        },
        title: {
          text: 'First response time'
        },
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            formatter: function () {
              return moment.duration(this.value, 'seconds').humanize()
            }
          }
        },
        xAxis: {
          type: 'datetime',
          categories: this.chartData.categories.map((data) => { return moment(data).format('MMM D') }),
          labels: {
            step: 3
          }
        },
        tooltip: {
          pointFormatter: function () {
            return moment.duration(this.y, 'seconds').humanize()
          }
        },
        series: [{
          name: 'First response time',
          data: this.chartData.data
        }]
      }
    }
  },
  methods: {
    getProductivityReport () {
      this.$http.get('/productivity_report', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then((response) => {
          this.resolved = response.data.resolved
          this.closedTasks = response.data.closed_tasks
          this.replies = response.data.replies
          this.chartData.categories = response.data.chart_data.categories
          this.chartData.data = response.data.chart_data.data
          this.firstResponseTime = moment.duration(response.data.avg_response, 'seconds').humanize()
          this.firstResponseTimes = response.data.first_response_times
          this.repliesToResolve = response.data.replies_to_resolve
          this.avgRepliesToResolve = response.data.avg_replies_to_resolve
          this.avgTaskTime = moment.duration(response.data.avg_task_time, 'seconds').humanize()
          this.avgTicketTime = moment.duration(response.data.avg_ticket_time, 'seconds').humanize()
          this.usersProductivity = response.data.users
          this.$root.$emit('reportLoadingComplete')
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('errorLoadingReport')
        })
    },
    getData () {
      if (this.currentReportMailbox.id) {
        this.$root.$emit('loadingReport')
        this.getProductivityReport()
        this.getTaskTemplateCollectionsStats()
      }
    },
    getTaskTemplateCollectionsStats () {
      var vm = this
      this.$http.get('/task_template_collections_stats', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then(function (response) {
          vm.taskTemplateCollections = response.data
        })
        .catch(e => { console.log(e) })
    },
    timeFormatter (value) {
      if (value > 0) {
        return moment.duration(value, 'seconds').humanize()
      } else {
        return 'N/A'
      }
    }
  },
  watch: {
    currentReportMailbox () {
      this.getData()
    },
    reportDates () {
      this.getData()
    }
  }

}
</script>
<style scoped>
@media (min-width: 992px) {
  .stats {
    width: 415px;
    background: 0 0;
    border-collapse: separate;
    border-spacing: 20px 0;
    table-layout: fixed;
    margin-top: 10px;
  }
}
  .stats {
    background: 0 0;
    border-collapse: separate;
    border-spacing: 20px 0;
    table-layout: fixed;
    width: 100%;
  }
  .stats p {
    color: #1b3046;
    cursor: help;
    font-size: 14px;
    margin-bottom: 2px;
  }

  .stats .data {
    color: #436d8c;
    font-size: 35px;
    margin-right: 12px;
  }
  .stat-tables {
    margin-top: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/components/admin/reports/ProductivityReport.vue